import React from "react";

const MySkeleton = () => {
  return (
    <div class="grid grid-cols-5 gap-4 p-4">
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>

      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>

      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>

      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>

      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
      <div class="animate-pulse bg-gray-200 h-32 rounded-md"></div>
    </div>
  );
};

export default MySkeleton;

export const CustomerRowSkeleton = () => (
  <div className="h-[44px] bg-white w-full flex items-center animate-pulse">
    <div className="w-[10%] flex justify-center">
      <div className="h-4 w-4 bg-gray-200 rounded" />
    </div>
    <div className="w-[13%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>
    <div className="w-[18%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[80%]" />
    </div>
    <div className="w-[13%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[70%]" />
    </div>
    <div className="w-[16%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[80%]" />
    </div>
    <div className="w-[13%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>
    <div className="w-[18%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[70%]" />
    </div>
    <div className="w-[16%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[50%]" />
    </div>
    {/* <div className="w-[8%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[50%]" />
    </div> */}
  </div>
);

export const TransactionRowSkeleton = () => (
  <div className="h-[44px] bg-white w-full flex items-center animate-pulse">
    <div className="w-[10%] flex justify-center">
      <div className="h-4 w-4 bg-gray-200 rounded" />
    </div>

    <div className="w-[14%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[70%]" />
    </div>

    <div className="w-[16%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[80%]" />
    </div>

    <div className="w-[12%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[75%]" />
    </div>

    <div className="w-[18%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[85%]" />
    </div>

    <div className="w-[16%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[70%]" />
    </div>

    <div className="w-[13%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[65%]" />
    </div>

    <div className="w-[13%] px-2">
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>

    <div className="w-[16.5%] px-2 flex items-center gap-2">
      <div className="h-3 w-3 bg-gray-200 rounded-full" />
      <div className="h-4 bg-gray-200 rounded w-[50%]" />
    </div>
  </div>
);

export const LoanRowSkeleton = () => (
  <div className="h-[44px] bg-white w-full flex items-center mt-[2px] animate-pulse">
    <div className="w-[10vw] flex justify-center">
      <div className="h-4 w-4 bg-gray-200 rounded" />
    </div>

    <div className="w-[16vw] px-2">
      <div className="h-4 bg-gray-200 rounded w-[70%]" />
    </div>

    <div className="w-[30vw] px-2">
      <div className="h-4 bg-gray-200 rounded w-[85%]" />
    </div>

    <div className="w-[20vw] px-2">
      <div className="h-4 bg-gray-200 rounded w-[75%]" />
    </div>

    <div className="w-[24vw] px-2">
      <div className="h-4 bg-gray-200 rounded w-[70%]" />
    </div>

    <div className="w-[22vw] px-2">
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>

    <div className="w-[18vw] px-2">
      <div className="h-4 bg-gray-200 rounded w-[50%]" />
    </div>

    <div className="w-[28vw] px-2">
      <div className="h-4 bg-gray-200 rounded w-[80%]" />
    </div>

    <div className="w-[24vw] px-2">
      <div className="h-4 bg-gray-200 rounded w-[65%]" />
    </div>

    <div className="w-[28vw] px-2 flex items-center gap-2">
      <div className="h-3 w-3 bg-gray-200 rounded-full" />
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>
  </div>
);

export const GuarantorRowSkeleton = () => (
  <div className="h-[44px] bg-[#fff] w-full flex items-center animate-pulse mt-[2px]">
    <div className="w-[15%] flex justify-center">
      <div className="h-4 w-4 bg-gray-200 rounded" />
    </div>

    <div className="w-[22%] px-1">
      <div className="h-4 bg-gray-200 rounded w-[70%]" />
    </div>

    <div className="w-[38%] px-1">
      <div className="h-4 bg-gray-200 rounded w-[85%]" />
    </div>

    <div className="w-[25%] px-1">
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>

    <div className="w-[18%] px-1">
      <div className="h-4 bg-gray-200 rounded w-[50%]" />
    </div>

    <div className="w-[25%] px-1">
      <div className="h-4 bg-gray-200 rounded w-[50%]" />
    </div>

    <div className="w-[25%] px-1">
      <div className="h-4 bg-gray-200 rounded w-[50%]" />
    </div>
  </div>
);

export const AdminUserRowSkeleton = () => (
  <div className="h-[44px] bg-white w-full flex items-center animate-pulse mt-[2px]">
    {/* Checkbox */}
    <div className="w-[10vw] flex justify-center">
      <div className="h-4 w-4 bg-gray-200 rounded" />
    </div>

    {/* USER ID */}
    <div className="w-[14vw] px-1">
      <div className="h-4 bg-gray-200 rounded w-[70%]" />
    </div>

    {/* FULL NAME */}
    <div className="w-[22vw] px-1">
      <div className="h-4 bg-gray-200 rounded w-[80%]" />
    </div>

    {/* EMAIL */}
    <div className="w-[45vw] px-1">
      <div className="h-4 bg-gray-200 rounded w-[85%]" />
    </div>

    {/* ROLE */}
    <div className="w-[20vw] px-1">
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>

    {/* CREATED ON */}
    <div className="w-[20vw] px-1">
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>

    {/* STATUS */}
    <div className="w-[22vw] flex items-center gap-2 px-1">
      <div className="h-3 w-3 bg-gray-200 rounded-full" />
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>
  </div>
);

export const AuditTrailRowSkeleton = () => (
  <div className="h-[37px] bg-white w-full flex items-center animate-pulse mb-[7px]">
    {/* Checkbox */}
    <div className="w-[5%] flex justify-center px-[10px]">
      <div className="h-4 w-4 bg-gray-200 rounded" />
    </div>

    {/* ACTION CATEGORY */}
    <div className="w-[15%] px-[10px]">
      <div className="h-4 bg-gray-200 rounded w-[70%]" />
    </div>

    {/* ACTION DESCRIPTION */}
    <div className="w-[30%] px-[10px]">
      <div className="h-4 bg-gray-200 rounded w-[85%]" />
    </div>

    {/* USER */}
    <div className="w-[15%] px-[10px]">
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>

    {/* IP ADDRESS */}
    <div className="w-[20%] px-[10px]">
      <div className="h-4 bg-gray-200 rounded w-[75%]" />
    </div>

    {/* DATE/TIME */}
    <div className="w-[15%] px-[10px]">
      <div className="h-4 bg-gray-200 rounded w-[60%]" />
    </div>
  </div>
);
